import { useTranslation } from "react-i18next";

import { Avatar, Button, Header } from "@pentabd/ui";

export const TransferHeader = ({
  data: { employeeName, employeePosition, employeeImage },
  isUploadedJoiningLetter,
  showActionButton,
  isLoading,
}: {
  data: any;
  isUploadedJoiningLetter: boolean;
  showActionButton: boolean;
  isLoading?: boolean;
}) => {
  const { t } = useTranslation();

  const actionButtons = [
    <Button
      key="transfer_details_top"
      htmlType="submit"
      fill="fill"
      type="default"
      className="bg-primary-lighter border border-primary-light text-primary"
      loading={isLoading}
    >
      {isUploadedJoiningLetter
        ? t("TRANSFER.ACTION_BUTTONS.COMPLETE")
        : t("TRANSFER.ACTION_BUTTONS.SAVE")}
    </Button>,
  ];

  return (
    <div className="sticky-body bg-white">
      <Header
        size="sm"
        headerText={{
          header: employeeName,
          subHeader: employeePosition,
        }}
        actions={showActionButton ? actionButtons : undefined}
        className="px-9 py-8"
        avatar={
          <Avatar size="xm" name={employeeName} imageURL={employeeImage} />
        }
      />
    </div>
  );
};
